/* tslint:disable */
/* eslint-disable */
/**
 * Vayu API
 * The Vayu API is a RESTful API that allows you to submit events for processing and storage & manage billing related entities.           The API is secured using the Bearer Authentication scheme with JWT tokens.           To obtain a JWT token, please contact Vayu at team@withvayu.com
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dev@withvayu.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
    CommercialTermsPricing,
    instanceOfCommercialTermsPricing,
    CommercialTermsPricingFromJSON,
    CommercialTermsPricingFromJSONTyped,
    CommercialTermsPricingToJSON,
} from './CommercialTermsPricing';
import {
    CommissionPricing,
    instanceOfCommissionPricing,
    CommissionPricingFromJSON,
    CommissionPricingFromJSONTyped,
    CommissionPricingToJSON,
} from './CommissionPricing';
import {
    FixedPerUnitPricing,
    instanceOfFixedPerUnitPricing,
    FixedPerUnitPricingFromJSON,
    FixedPerUnitPricingFromJSONTyped,
    FixedPerUnitPricingToJSON,
} from './FixedPerUnitPricing';
import {
    InstallmentsPricing,
    instanceOfInstallmentsPricing,
    InstallmentsPricingFromJSON,
    InstallmentsPricingFromJSONTyped,
    InstallmentsPricingToJSON,
} from './InstallmentsPricing';
import {
    OneTimePricing,
    instanceOfOneTimePricing,
    OneTimePricingFromJSON,
    OneTimePricingFromJSONTyped,
    OneTimePricingToJSON,
} from './OneTimePricing';
import {
    PerUnitPricing,
    instanceOfPerUnitPricing,
    PerUnitPricingFromJSON,
    PerUnitPricingFromJSONTyped,
    PerUnitPricingToJSON,
} from './PerUnitPricing';
import {
    RecurringPricing,
    instanceOfRecurringPricing,
    RecurringPricingFromJSON,
    RecurringPricingFromJSONTyped,
    RecurringPricingToJSON,
} from './RecurringPricing';
import {
    RefundPricing,
    instanceOfRefundPricing,
    RefundPricingFromJSON,
    RefundPricingFromJSONTyped,
    RefundPricingToJSON,
} from './RefundPricing';
import {
    TieredSubscriptionPricing,
    instanceOfTieredSubscriptionPricing,
    TieredSubscriptionPricingFromJSON,
    TieredSubscriptionPricingFromJSONTyped,
    TieredSubscriptionPricingToJSON,
} from './TieredSubscriptionPricing';
import {
    TiersPricing,
    instanceOfTiersPricing,
    TiersPricingFromJSON,
    TiersPricingFromJSONTyped,
    TiersPricingToJSON,
} from './TiersPricing';

/**
 * @type Pricing
 * 
 * @export
 */
export type Pricing = { pricingModel: 'CommercialTerms' } & CommercialTermsPricing | { pricingModel: 'Commission' } & CommissionPricing | { pricingModel: 'FixedOneTime' } & OneTimePricing | { pricingModel: 'FixedPerUnit' } & FixedPerUnitPricing | { pricingModel: 'Installments' } & InstallmentsPricing | { pricingModel: 'PerUnit' } & PerUnitPricing | { pricingModel: 'Refund' } & RefundPricing | { pricingModel: 'Subscription' } & RecurringPricing | { pricingModel: 'TieredSubscription' } & TieredSubscriptionPricing | { pricingModel: 'Tiers' } & TiersPricing;

export function PricingFromJSON(json: any): Pricing {
    return PricingFromJSONTyped(json, false);
}

export function PricingFromJSONTyped(json: any, ignoreDiscriminator: boolean): Pricing {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    switch (json['pricingModel']) {
        case 'CommercialTerms':
            return {...CommercialTermsPricingFromJSONTyped(json, true), pricingModel: 'CommercialTerms'};
        case 'Commission':
            return {...CommissionPricingFromJSONTyped(json, true), pricingModel: 'Commission'};
        case 'FixedOneTime':
            return {...OneTimePricingFromJSONTyped(json, true), pricingModel: 'FixedOneTime'};
        case 'FixedPerUnit':
            return {...FixedPerUnitPricingFromJSONTyped(json, true), pricingModel: 'FixedPerUnit'};
        case 'Installments':
            return {...InstallmentsPricingFromJSONTyped(json, true), pricingModel: 'Installments'};
        case 'PerUnit':
            return {...PerUnitPricingFromJSONTyped(json, true), pricingModel: 'PerUnit'};
        case 'Refund':
            return {...RefundPricingFromJSONTyped(json, true), pricingModel: 'Refund'};
        case 'Subscription':
            return {...RecurringPricingFromJSONTyped(json, true), pricingModel: 'Subscription'};
        case 'TieredSubscription':
            return {...TieredSubscriptionPricingFromJSONTyped(json, true), pricingModel: 'TieredSubscription'};
        case 'Tiers':
            return {...TiersPricingFromJSONTyped(json, true), pricingModel: 'Tiers'};
        default:
            throw new Error(`No variant of Pricing exists with 'pricingModel=${json['pricingModel']}'`);
    }
}

export function PricingToJSON(value?: Pricing | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    switch (value['pricingModel']) {
        case 'CommercialTerms':
            return CommercialTermsPricingToJSON(value);
        case 'Commission':
            return CommissionPricingToJSON(value);
        case 'FixedOneTime':
            return OneTimePricingToJSON(value);
        case 'FixedPerUnit':
            return FixedPerUnitPricingToJSON(value);
        case 'Installments':
            return InstallmentsPricingToJSON(value);
        case 'PerUnit':
            return PerUnitPricingToJSON(value);
        case 'Refund':
            return RefundPricingToJSON(value);
        case 'Subscription':
            return RecurringPricingToJSON(value);
        case 'TieredSubscription':
            return TieredSubscriptionPricingToJSON(value);
        case 'Tiers':
            return TiersPricingToJSON(value);
        default:
            throw new Error(`No variant of Pricing exists with 'pricingModel=${value['pricingModel']}'`);
    }

}

